.gas-shop-catalog-react {
    display: block;
    container-type: inline-size;
}

.gas-shop-catalog-react__toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-spacing-md, 10px);
    margin-bottom: var(--gas-spacing-lg, 15px);
    align-items: center;
}

.gas-shop-catalog-react__search {
    flex: 1 1 280px;
}

.gas-shop-catalog-react__search-input,
.gas-shop-catalog-react__lines-select {
    width: 100%;
    height: var(--gas-input-height, 25px);
    padding: 0 var(--gas-spacing-sm, 8.75px);
    line-height: 1.2;
    box-sizing: border-box;
    border: 1px solid var(--gas-border-default, #e2e2e2);
    border-radius: var(--gas-radius-md, 8px);
    font-size: var(--gas-font-size-sm, 9.375px);
    background: var(--gas-bg-surface, #fff);
    color: var(--gas-text-primary, #1a1a1a);
}

.gas-shop-catalog-react__type-filters {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-spacing-xs, 5px);
}

.gas-shop-catalog-react__type-pill {
    padding: 4px 8.75px;
    background: var(--gas-bg-muted, #f5f5f5);
    border: 1px solid transparent;
    border-radius: var(--gas-radius-pill, 999px);
    font-size: var(--gas-font-size-sm, 8.75px);
    color: var(--gas-text-secondary, #666);
    cursor: pointer;
}

.gas-shop-catalog-react__type-pill:hover {
    background: var(--gas-bg-hover, #ebebeb);
}

.gas-shop-catalog-react__type-pill.is-active {
    background: var(--gas-color-primary, #0066cc);
    color: var(--gas-color-on-primary, #fff);
    border-color: var(--gas-color-primary, #0066cc);
}

.gas-shop-catalog-react__clear,
.gas-shop-catalog-react__see-all {
    background: transparent;
    border: none;
    color: var(--gas-color-primary, #0066cc);
    cursor: pointer;
    font-size: var(--gas-font-size-sm, 8.75px);
    padding: 0;
}

.gas-shop-catalog-react__count {
    color: var(--gas-text-secondary, #666);
    font-size: var(--gas-font-size-sm, 8.75px);
    margin: 0 0 var(--gas-spacing-md, 10px);
}

.gas-shop-catalog-react__tabs {
    margin-bottom: var(--gas-spacing-md, 10px);
}

.gas-shop-catalog-react__grid {
    display: grid;
    gap: var(--gas-spacing-md, 10px);
    margin-bottom: var(--gas-spacing-lg, 15px);
}

.gas-shop-catalog-react__grid--cols-1 { grid-template-columns: 1fr; }
.gas-shop-catalog-react__grid--cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.gas-shop-catalog-react__grid--cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.gas-shop-catalog-react__grid--cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }

.gas-shop-catalog-react__grid--membership-plan-only {
    grid-template-columns: repeat(auto-fit, minmax(280px, 380px));
    justify-content: center;
}

.gas-shop-catalog-react__card {
    background: var(--gas-bg-surface, #fff);
    border: 1px solid var(--gas-border-default, #e2e2e2);
    border-radius: var(--gas-radius-md, 8px);
    overflow: hidden;
}

.gas-shop-catalog-react__card-link {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: var(--gas-spacing-md, 10px);
    text-decoration: none;
    color: inherit;
}

.gas-shop-catalog-react__card-media {
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: var(--gas-radius-sm, 6px);
    overflow: hidden;
    background: var(--gas-bg-muted, #f5f5f5);
    border: 1px solid var(--gas-border-default, #e2e2e2);
    margin-bottom: var(--gas-spacing-sm, 7.5px);
}

.gas-shop-catalog-react__card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.gas-shop-catalog-react__card-image-placeholder {
    width: 100%;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: var(--gas-font-size-xl, 15px);
    font-weight: 600;
    color: var(--gas-text-secondary, #666);
}

.gas-shop-catalog-react__card-title {
    font-size: var(--gas-font-size-md, 11.25px);
    margin: var(--gas-spacing-sm, 7.5px) 0;
    line-height: 1.3;
    color: var(--gas-text-primary, #1a1a1a);
}

.gas-shop-catalog-react__card-description {
    font-size: var(--gas-font-size-sm, 8.75px);
    color: var(--gas-text-secondary, #666);
    margin: 0 0 var(--gas-spacing-md, 10px);
    flex-grow: 1;
}

.gas-shop-catalog-react__card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: var(--gas-spacing-sm, 7.5px);
    border-top: 1px solid var(--gas-border-default, #e2e2e2);
    margin-top: auto;
}

.gas-shop-catalog-react__card-price {
    font-weight: 600;
    color: var(--gas-text-primary, #1a1a1a);
}

.gas-shop-catalog-react__card-cta,
.gas-shop-catalog-react__table-link {
    color: var(--gas-color-primary, #0066cc);
    font-size: var(--gas-font-size-sm, 8.75px);
}

.gas-shop-catalog-react__card .gas-admin-badge {
    align-self: flex-start;
}

.gas-shop-catalog-react__badges {
    display: inline-flex;
    flex-wrap: wrap;
    gap: var(--gas-spacing-xs, 5px);
    align-items: center;
}

.gas-shop-catalog-react__lines-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-spacing-sm, 7.5px);
    align-items: center;
    margin-bottom: var(--gas-spacing-md, 10px);
}

.gas-shop-catalog-react__lines-label {
    font-size: var(--gas-font-size-sm, 8.75px);
    color: var(--gas-text-secondary, #666);
}

.gas-shop-catalog-react__lines-select {
    width: auto;
    min-width: 220px;
}

.gas-shop-catalog-react__lines-direction {
    height: var(--gas-input-height, 25px);
    min-width: var(--gas-input-height, 25px);
    padding: 0 var(--gas-spacing-sm, 7.5px);
    border: 1px solid var(--gas-border-default, #e2e2e2);
    border-radius: var(--gas-radius-md, 8px);
    background: var(--gas-bg-surface, #fff);
    color: var(--gas-text-primary, #1a1a1a);
    cursor: pointer;
}

.gas-shop-catalog-react__lines-wrap {
    width: 100%;
    overflow-x: auto;
}

.gas-shop-catalog-react__table {
    width: 100%;
    border-collapse: collapse;
    min-width: 680px;
}

.gas-shop-catalog-react__table th,
.gas-shop-catalog-react__table td {
    padding: var(--gas-spacing-sm, 7.5px);
    border-bottom: 1px solid var(--gas-border-default, #e2e2e2);
    text-align: left;
    vertical-align: middle;
}

.gas-shop-catalog-react__table code {
    font-size: var(--gas-font-size-xs, 7.5px);
}

.gas-shop-catalog-react__table th {
    color: var(--gas-text-secondary, #666);
    font-size: var(--gas-font-size-xs, 7.5px);
    text-transform: uppercase;
    letter-spacing: 0.02em;
}

.gas-shop-catalog-react__pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: var(--gas-spacing-sm, 7.5px);
    margin-top: var(--gas-spacing-lg, 15px);
}

.gas-shop-catalog-react__pagination-pages {
    display: inline-flex;
    flex-wrap: wrap;
    gap: var(--gas-spacing-xs, 5px);
}

.gas-shop-catalog-react__page-button {
    min-width: 20px;
    height: 20px;
    padding: 0 var(--gas-spacing-xs, 5px);
    border: 1px solid var(--gas-border-default, #e2e2e2);
    border-radius: var(--gas-radius-sm, 6px);
    background: var(--gas-bg-surface, #fff);
    color: var(--gas-text-primary, #1a1a1a);
    cursor: pointer;
}

.gas-shop-catalog-react__page-button.is-active {
    background: var(--gas-color-primary, #0066cc);
    border-color: var(--gas-color-primary, #0066cc);
    color: var(--gas-color-on-primary, #fff);
}

@media (max-width: 1024px) {
    .gas-shop-catalog-react__grid--cols-3,
    .gas-shop-catalog-react__grid--cols-4 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 640px) {
    .gas-shop-catalog-react__grid--cols-2,
    .gas-shop-catalog-react__grid--cols-3,
    .gas-shop-catalog-react__grid--cols-4 {
        grid-template-columns: 1fr;
    }

    .gas-shop-catalog-react__lines-select {
        min-width: 100%;
        width: 100%;
    }
}

@container (max-width: 1024px) {
    .gas-shop-catalog-react__grid--cols-3,
    .gas-shop-catalog-react__grid--cols-4 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@container (max-width: 640px) {
    .gas-shop-catalog-react__grid--cols-2,
    .gas-shop-catalog-react__grid--cols-3,
    .gas-shop-catalog-react__grid--cols-4 {
        grid-template-columns: 1fr;
    }

    .gas-shop-catalog-react__lines-select {
        min-width: 100%;
        width: 100%;
    }
}
